import React, { useContext } from 'react'

import { IAuthShieldContextValue } from './types'

export const AuthShieldContext = React.createContext({
  isAuthed: false,
  isLoggingOut: false,
} as IAuthShieldContextValue)

export const useIsAuthed = () => {
  const { isAuthed } = useContext<IAuthShieldContextValue>(AuthShieldContext)
  return isAuthed
}

export const useIsLoggingOut = () => {
  const { isLoggingOut } = useContext<IAuthShieldContextValue>(AuthShieldContext)
  return isLoggingOut
}
